import { type EditorPlugin } from '../../types/aha-editor';
import LinkCardComponent from './components/LinkCardComponent';
import ToolEditLinkCardUrl from './tools/ToolEditLinkCardUrl';
import ToolEditLinkCardText from './tools/ToolEditLinkCardText';
import ToolUploadImageLinkCard from './tools/ToolUploadImageLinkCard';
import ToolUnlinkCard from './tools/ToolUnlinkCard';
import LinkCardSchemaPlugin from './LinkCardSchemaPlugin';
import ToolLinkCardSize from './tools/ToolLinkCardSize';
import ToolLinkCardOrientation from './tools/ToolLinkCardOrientation';
import ToolLinkCardAlignment from './tools/ToolLinkCardAlignment';
import ToolOpenLinkCard from './tools/ToolOpenLinkCard';

export const LinkCardComponentPlugin: EditorPlugin = {
  name: 'LinkCard component plugin',
  components: [
    {
      type: 'linkCard',
      component: LinkCardComponent,
      toolbarItems: [
        [ToolOpenLinkCard],
        [ToolEditLinkCardText],
        [ToolUploadImageLinkCard, ToolLinkCardOrientation],
        [ToolLinkCardSize],
        [ToolLinkCardAlignment],
        [ToolEditLinkCardUrl],
        [ToolUnlinkCard],
      ],
    },
  ],
};

const LinkCardPlugin: EditorPlugin[] = [
  LinkCardSchemaPlugin,
  LinkCardComponentPlugin,
];

export default LinkCardPlugin;
